import { render, staticRenderFns } from "./PublicHome.vue?vue&type=template&id=59480762&"
import script from "./PublicHome.vue?vue&type=script&lang=js&"
export * from "./PublicHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports